import * as ActionTypes from '../../actions/actionTypes'
import * as actions from '../../actions/dobovoActions'
import { getParser } from '../../adapters'
import { handleError, handleResponse, securedFetch } from '../apiUtils'
import * as urls from '../urls'

/** @thunk **/
export const fetchEasymsDobovoCategories = organizationId => (dispatch, getState) => {
    dispatch({ type: ActionTypes.DOBOVO_EASYMS_CATEGORIES_FETCH_REQUEST })
    const { auth } = getState()

    securedFetch(urls.easymsCategories(organizationId), auth, { method: 'GET' })
        .then(handleResponse)
        .then(json => dispatch(actions.dobovo_fetchEasymsCategoriesSuccess(getParser(urls.easymsCategories)(json))))
        .catch(
            handleError(
                dispatch,
                actions.dobovo_fetchEasymsCategoriesFailure,
                'Что-то пошло не так!',
                'При получении категорий EasyMS произошла ошибка'
            )
        )
}

/** @thunk **/
export const fetchEasymsDobovoRates = organizationId => (dispatch, getState) => {
    dispatch({ type: ActionTypes.DOBOVO_EASYMS_RATES_FETCH_REQUEST })
    const { auth } = getState()

    securedFetch(urls.easymsRates(organizationId), auth, { method: 'GET' })
        .then(handleResponse)
        .then(json => dispatch(actions.dobovo_fetchEasymsRatesSuccess(getParser(urls.easymsRates)(json))))
        .catch(
            handleError(
                dispatch,
                actions.dobovo_fetchEasymsRatesFailure,
                'Что-то пошло не так!',
                'При получении тарифов EasyMS произошла ошибка'
            )
        )
}



// WEBPACK FOOTER //
// ./src/api/dobovoApi/dobovoEasyms.js